"use client";

import React from "react";
import { PageFuturesSchema } from "@/sanity/pages/PageFuturesTemplate";

import { usePathname } from "next/navigation";
import { PortableText } from "@portabletext/react";
import { richTextComponent } from "@/sanity/sanityPortableText";
import PricingTable from "./PricingTable";
import ChipSerif from "@/components/global/ui/ChipSerif";
import { cn } from "@/lib/utils";
import { CTAButton } from "@/shadcn/ui/button";

export default function FundingSection({
  data,
  className,
  futures = false,
}: {
  data: PageFuturesSchema;
  className?: string;
  futures?: boolean;
}) {
  const pathname = usePathname();
  const lang =
    pathname.slice(-3) === "/de" || pathname === "/de"
      ? "de"
      : pathname.slice(-3) === "/br" || pathname === "/br"
        ? "br"
        : "en";
  return (
    <section
      id="pricing"
      className={cn("w-full h-full lg:px-0", className)}
      style={{ overflowAnchor: "none" }}
    >
      <div className="container relative">
        <div className="w-[min(146.625rem,100%)] mx-auto">
          <div className="flex flex-col justify-center items-center lg:justify-start mb-[3rem] lg:mb-[4rem]">
            <ChipSerif text={data?.tableChip} />

            {data?.tableTitle && (
              <div className="richtext prose-p:w-[min(56.5rem,100%)]">
                <PortableText
                  value={data.tableTitle}
                  components={richTextComponent}
                />
              </div>
            )}
          </div>

          <PricingTable
            data={data?.prices ?? []}
            stepOneTitle={data?.stepOneTitle ?? ""}
            stepTwoTitle={data?.stepTwoTitle ?? ""}
            stepThreeTitle={data?.stepThreeTitle ?? ""}
            stepPriceText={data?.stepPriceText}
            lang={lang}
            showBanner={(data as any)?.showTopBanner}
            showFlashSaleBanner={data?.showFlashSaleBanner}
            flashSaleBannerTitle={data?.flashSaleBannerTitle}
            flashSaleBannerText={data?.flashSaleBannerText}
            flashSaleBannerCTA={data?.flashSaleBannerCTA}
            futures={futures}
          />
        </div>
        {data?.fundingCTA && (
          <div className="flex relative z-10 justify-center pt-[5rem]">
            <CTAButton data={data.fundingCTA} />
          </div>
        )}
      </div>
    </section>
  );
}
